/**
 * @file 菜单
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';

import home from './home';
import sale from './sale';
// import account from './account';
// import report from './report';
import finance from './finance';
// import task from './task';
// import assets from './assets';
import oppotunity from './oppotunity';
import toolbox from './toolbox';
import manage from './manage';
import knowledge from './knowledge';
import sysadmin from './sysadmin';
import download from './download';
import notice from './notice';
import personal from './personal';
import growup from './growup';
import advertising from './advertising';
import strategy from './strategy';
import aiAgent from './ai-agent';


/**
 * @description 用于生成菜单、路由
 * key：用来区分弹窗提示和页面指导手册
 * label：页面名称
 * desc：导航提示文案
 * platform：平台
 * enableKey：功能开关
 * disabled：禁用当前及所有子目录
 * purview：运营权限
 * perm：销售权限
 * pagePurview：页面内功能权限
 * behavior：行为
 * useNavOpenReport：菜单点击上报
 * navOpenReportParams：菜单点击上报参数
 * path：用于菜单高亮
 * hideTabNav：隐藏二级菜单
 * singleTabNav：二级菜单仅显示自己
 * hideSubNav：隐藏三级菜单
 * showSideNav: 是否展示侧边菜单，默认展示
 */
const menus = [
  // 首页
  ...home,
  // 投放
  ...advertising,
  // 机会
  ...oppotunity,
  // 成长中心
  ...growup,
  // 管理
  ...manage,
  // 策略
  ...strategy,
  // 财务
  ...finance,
  // 客户
  // ...account,
  // 报表
  // ...report,
  // 任务
  // ...task,
  // 资产
  // ...assets,
  // 工具
  ...toolbox,
  // 知识
  ...knowledge,
  // 销售
  ...sale,
  // 系统管理
  ...sysadmin,
  // 下载中心
  ...download,
  // 消息中心
  ...notice,
  // 个人中心
  ...personal,
  // AI 助理
  ...aiAgent,
];

export default menus;
